angular.module('tradersyard').factory('webinar-query-filter', [
    '$flex',
    function ($flex) {
        var knowing = ['recommended', 'all', 'upcoming', 'joined', 'closed', 'my', 'own', 'own-upcoming'],
            hash,
            tab,
            orders = {
                recommended: 'asc',
                all: 'asc',
                upcoming: 'asc',
                closed: null,
                my: 'asc',
                own: 'asc',
            };

        var params = {
            page: 0,
            limit: 25,
        };

        var filter = {
            init: function () {
                filter.set(filter.get());
            },
            is: function (name) {
                return (
                    (tab !== undefined ? tab.split('.')[filter.level] : tab) === name &&
                    (filter.parent !== undefined && tab !== undefined ? tab.split('.')[0] === filter.parent : true)
                );
            },
            get: function () {
                hash = $flex.$hash.get();

                return knowing.indexOf(hash.split('.')[filter.level]) !== -1
                    ? hash.split('.')[filter.level]
                    : 'upcoming';
            },
            set: function (name) {
                var _name = filter.parent === undefined ? name : [filter.parent, name].join('.');
                // name = filter.parent === undefined ? name : [filter.parent, name].join('.');

                if (tab !== _name) {
                    tab = _name;

                    if (orders[name] !== null) {
                        params.order = orders[name];
                    } else if (params.hasOwnProperty('order')) {
                        delete params.order;
                    }

                    if (_name === 'recommended') {
                        params.recommended = true;
                        params.filter = 'all';
                    } else {
                        params.filter = name;

                        if (params.hasOwnProperty('recommended')) {
                            delete params.recommended;
                        }
                    }

                    params.page = 0;

                    if (filter.on.change) filter.on.change();

                    if (filter.catch === true) {
                        if (filter.get() !== _name) $flex.$hash.set(_name);
                    }
                }
            },
            params: params,
            on: {
                change: undefined,
            },
            catch: true,
            level: 0,
            parent: undefined,
        };

        params.filter = filter.get();

        return filter;
    },
]);
